import React from 'react'
import { RiLogoutBoxRLine } from 'react-icons/ri'
import { useNavigate } from 'react-router-dom'

const HeaderMenu = ({ headerMenu, setHeaderMenu }) => {

    const navigate = useNavigate();

    // Session
    const sessionKill = () => {
        sessionStorage.removeItem("SmiliesOnlineLog");
        navigate('/')
    }

    return (
        <article className={`${headerMenu ? 'headerMenuActive' : ''} header__menu`}>
            <div className='header__menu-options' onClick={sessionKill} >
                <RiLogoutBoxRLine className='icon-main color-danger-muted' />
                <span>Odjava</span>
            </div>
        </article>
    )
}

export default HeaderMenu